var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"translate",rawName:"v-translate"}],staticClass:"button is-primary",class:{ 'is-loading': _vm.isLoading },on:{"click":_vm.downloadOutings}},[_vm._v("\n  Download outings\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }